// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as OutboundOrderDashboardCmp from "./components/OutboundOrderDashboardCmp.bs.js";
import * as OrderDashboardStateMachine from "../../../app/order/OrderDashboardStateMachine.bs.js";
import * as NLOrderDashboardAssetsManager from "../../assets/NLOrderDashboardAssetsManager.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

NLOrderDashboardAssetsManager.importCss(undefined);

function isHelperOrder(order_details) {
  switch (order_details.TAG | 0) {
    case /* Open */0 :
        var match = order_details._0;
        if (match.is_helper_order || match.is_helper_plus_labour) {
          return true;
        } else {
          return false;
        }
    case /* Accepted */1 :
        var match$1 = order_details._0;
        if (match$1.is_helper_order || match$1.is_helper_plus_labour) {
          return true;
        } else {
          return false;
        }
    case /* Live */2 :
        var match$2 = order_details._0;
        if (match$2.is_helper_order || match$2.is_helper_plus_labour) {
          return true;
        } else {
          return false;
        }
    case /* Ended */3 :
        var match$3 = order_details._0;
        if (match$3.is_helper_order || match$3.is_helper_plus_labour) {
          return true;
        } else {
          return false;
        }
    case /* Cancelled */4 :
        var match$4 = order_details._0;
        if (match$4.is_helper_order || match$4.is_helper_plus_labour) {
          return true;
        } else {
          return false;
        }
    case /* CancelledAccepted */5 :
        var match$5 = order_details._0;
        if (match$5.is_helper_order || match$5.is_helper_plus_labour) {
          return true;
        } else {
          return false;
        }
    case /* CancelledLive */6 :
        var match$6 = order_details._0;
        if (match$6.is_helper_order || match$6.is_helper_plus_labour) {
          return true;
        } else {
          return false;
        }
    case /* CancelledCompleted */7 :
        var match$7 = order_details._0;
        if (match$7.is_helper_order || match$7.is_helper_plus_labour) {
          return true;
        } else {
          return false;
        }
    case /* CancelledEnded */8 :
        var match$8 = order_details._0;
        if (match$8.is_helper_order || match$8.is_helper_plus_labour) {
          return true;
        } else {
          return false;
        }
    
  }
}

function OutboundOrderDashboardContainer(Props) {
  var order_crn = Props.order_crn;
  var is_edit_order_open = Props.is_edit_order_open;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer((function (state, action) {
          return OrderDashboardStateMachine.reducer(action, state);
        }), /* LoadingData */0);
  var dispatch = match$1[1];
  var state = match$1[0];
  React.useEffect((function () {
          OrderDashboardStateMachine.fetchBaseData(order_crn, dispatch, country);
          
        }), []);
  var loadAssistInfoFetchedRef = React.useRef(false);
  React.useEffect((function () {
          if (typeof state !== "number" && state.TAG === /* Dashboard */0) {
            switch (state.tickets.TAG | 0) {
              case /* Loading */0 :
                  OrderDashboardStateMachine.fetchTickets(order_crn, dispatch)(country);
                  break;
              case /* Live */1 :
              case /* Error */2 :
                  break;
              
            }
          }
          if (typeof state !== "number" && state.TAG === /* Dashboard */0 && country.TAG === /* India */1) {
            switch (state.scheduled_order_data.TAG | 0) {
              case /* Loading */0 :
                  OrderDashboardStateMachine.fetchOrderSchedule(order_crn, country, dispatch);
                  break;
              case /* Live */1 :
              case /* Error */2 :
                  break;
              
            }
          }
          if (typeof state !== "number" && state.TAG === /* Dashboard */0) {
            if (!loadAssistInfoFetchedRef.current && state.load_assist_info === undefined && isHelperOrder(state.order_details) && order_crn !== "") {
              loadAssistInfoFetchedRef.current = true;
              OrderDashboardStateMachine.fetchLoadAssistInfo(order_crn, country, dispatch);
            }
            
          }
          
        }), [state]);
  if (typeof state === "number") {
    return React.createElement(CircularLoader$Catalyst.make, {});
  } else if (state.TAG === /* Dashboard */0) {
    return React.createElement(OutboundOrderDashboardCmp.make, {
                order_crn: order_crn,
                order_details: state.order_details,
                order_fare: state.order_fare,
                user: state.user,
                tickets: state.tickets,
                is_edit_order_open: is_edit_order_open,
                scheduled_order_data: state.scheduled_order_data,
                load_assist_info: state.load_assist_info
              });
  } else {
    return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: state._0
              });
  }
}

var make = OutboundOrderDashboardContainer;

export {
  isHelperOrder ,
  make ,
  
}
/*  Not a pure module */
